(function () {
  'use strict';
  if (window.baHitSwitcherLoaded) return;
  window.baHitSwitcherLoaded = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const mobileRecords = new WeakMap();

  function syncInlineDetails(root) {
    if (!root.matches('.ba-hit-gallery')) return;
    root.querySelectorAll('[data-ba-inline-card]').forEach(function (card) {
      let record = mobileRecords.get(card);
      if (mobile.matches && !record) {
        const nodes = Array.from(card.childNodes).filter(function (node) {
          return node.nodeType === 1 ? !node.matches('[data-ba-hit-open], .ba-hit-archive-card__image, dialog, template, script, style') : node.nodeType === 3 && node.textContent.trim();
        });
        if (!nodes.length) return;
        const details = document.createElement('details');
        details.className = 'ba-hit-details';
        const summary = document.createElement('summary');
        summary.className = 'ba-hit-details__summary';
        const label = document.createElement('span');
        label.textContent = root.dataset.baDetailsLabel;
        summary.append(label);
        const title = card.querySelector('h3');
        if (title) {
          const context = document.createElement('span');
          context.className = 'visually-hidden';
          context.textContent = ': ' + title.textContent.trim();
          summary.append(context);
        }
        const body = document.createElement('div');
        body.className = 'ba-hit-details__body';
        details.append(summary, body);
        const entries = nodes.map(function (node) {
          const marker = document.createComment('ba-inline-details');
          card.insertBefore(marker, node);
          body.append(node);
          return { marker, node };
        });
        card.append(details);
        mobileRecords.set(card, { details, entries });
      } else if (!mobile.matches && record) {
        record.entries.forEach(entry => entry.marker.replaceWith(entry.node));
        record.details.remove();
        mobileRecords.delete(card);
      }
    });
  }
  mobile.addEventListener('change', function () {
    document.querySelectorAll('[data-ba-hit-switcher]').forEach(syncInlineDetails);
  });

  function setup(root) {
    if (root.dataset.baHitSwitcherReady) return;
    const nav = root.querySelector('[data-ba-hit-switch-nav]');
    const grid = root.querySelector('[data-ba-hit-switch-grid]');
    if (!nav || !grid) return;
    root.dataset.baHitSwitcherReady = 'true';
    const links = Array.from(nav.querySelectorAll('a[href]'));
    const cache = new Map();
    let request = 0;
    let controller;
    let selected = links.find(link => link.hasAttribute('aria-current')) || links[0];
    const status = document.createElement('p');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    nav.after(status);

    links.forEach(function (link) {
      link.setAttribute('role', 'button');
      link.setAttribute('aria-pressed', String(link === selected));
      link.removeAttribute('aria-current');
      link.querySelectorAll('[aria-hidden]').forEach(icon => icon.remove());
      link.addEventListener('keydown', function (event) {
        if (event.key === ' ') {
          event.preventDefault();
          link.click();
        }
      });
    });

    function prepareCards(source) {
      const fragment = document.createDocumentFragment();
      const scope = root.dataset.baHitCardScope;
      Array.from(source.children).filter(node => node.matches('[data-ba-hit-card]')).forEach(function (original) {
        const card = original.cloneNode(true);
        card.setAttribute('data-ba-inline-card', '');
        // Keep the existing Craft card styling and unique video dialog identities.
        if (scope) {
          const className = Array.from(card.classList).find(name => name.startsWith('ai-bounty-card-'));
          const previous = className && className.slice('ai-bounty-card-'.length);
          if (previous) {
            [card, ...card.querySelectorAll('*')].forEach(function (node) {
              Array.from(node.classList).forEach(function (name) {
                if (name.endsWith('-' + previous)) {
                  node.classList.replace(name, name.slice(0, -previous.length) + scope);
                }
              });
            });
          }
        }
        const ids = new Map();
        card.querySelectorAll('[id]').forEach(function (node) {
          const oldId = node.id;
          node.id = 'ba-inline-' + root.dataset.baHitSwitcher + '-' + oldId;
          ids.set(oldId, node.id);
        });
        card.querySelectorAll('[aria-controls], [aria-labelledby]').forEach(function (node) {
          ['aria-controls', 'aria-labelledby'].forEach(function (attribute) {
            if (node.hasAttribute(attribute)) {
              node.setAttribute(attribute, node.getAttribute(attribute).split(/\s+/).map(id => ids.get(id) || id).join(' '));
            }
          });
        });
        fragment.append(card);
      });
      return fragment;
    }

    nav.addEventListener('click', async function (event) {
      const link = event.target.closest('a[href]');
      if (!link || !links.includes(link) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      event.preventDefault();
      const current = ++request;
      if (controller) controller.abort();
      controller = new AbortController();
      const requestController = controller;
      const timeout = setTimeout(() => requestController.abort(), 15000);
      grid.setAttribute('aria-busy', 'true');
      status.className = 'visually-hidden';
      status.textContent = 'Henter kort …';
      try {
        let source = cache.get(url.href);
        if (!source) {
          const response = await fetch(url.href, { credentials: 'same-origin', signal: requestController.signal });
          if (!response.ok) throw new Error('gallery-response');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          source = html.querySelector('.ba-hit-gallery__grid');
          if (!source || !source.querySelector('[data-ba-hit-card]')) throw new Error('gallery-empty');
          cache.set(url.href, source);
        }
        if (current !== request || !root.isConnected) return;
        const navTop = nav.getBoundingClientRect().top;
        grid.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        grid.replaceChildren(prepareCards(source));
        grid.dataset.baHitLoaded = link.dataset.baHitFilter || '';
        const section = root.closest('.shopify-section');
        if (root.dataset.baHitLegacy === 'true' && section) {
          section.querySelectorAll('[data-ba-hit-legacy]').forEach(function (legacy) {
            if (legacy !== root) legacy.hidden = true;
          });
        }
        selected = link;
        links.forEach(item => item.setAttribute('aria-pressed', String(item === selected)));
        root.dispatchEvent(new CustomEvent('ba:hits:updated', { bubbles: true }));
        syncInlineDetails(root);
        const difference = nav.getBoundingClientRect().top - navTop;
        if (Math.abs(difference) > 1) window.scrollBy(0, difference);
        status.textContent = link.textContent.trim() + ': ' + grid.children.length + ' kort vises.';
      } catch (error) {
        if (current !== request || !root.isConnected) return;
        status.className = 'ba-hit-switch-error';
        status.textContent = 'Kunne ikke hente kortene. Trykk på valget igjen for å prøve på nytt.';
      } finally {
        clearTimeout(timeout);
        if (current === request) grid.removeAttribute('aria-busy');
      }
    });
  }

  function init(container) {
    if (container.matches && container.matches('[data-ba-hit-switcher]')) setup(container);
    container.querySelectorAll('[data-ba-hit-switcher]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
